module.exports = __webpack_public_path__ + "static/media/nano-sample.db4784fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arts/samples/nano-sample.jpg
// module id = 415
// module chunks = 0